import { JobsBillingCard } from "@app/views-interfaces";

export interface IJobsJobAccess {
    job_status: boolean;
    view_job: (card: JobsBillingCard) => boolean;
    job_notes: boolean;
    job_priority: boolean;
    currently_responsible: boolean;
    job_partner: boolean;
    job_manager: boolean;
    job_owner: boolean;
    target_start_date: boolean;
    target_end_date: boolean;
    job_group_1: boolean;
    job_group_2: boolean;
    drag_drop: boolean;
}

export type JobsJobAccessField = keyof IJobsJobAccess;

export const JobsJobAccessField: Record<string, JobsJobAccessField> = {
    jobPartner: "job_partner",
    jobManager: "job_manager",
    jobOwner: "job_owner",
    currentlyResponsible: "currently_responsible",
    jobGroup1: "job_group_1",
    jobGroup2: "job_group_2",
} as const;
